module.exports = __webpack_public_path__ + "13b0d7dd844c7f7abccc478662f0be05.png";